import React from "react"
import './index.scss'

let Paragraph = ({ children }) => (<div className="Paragraph">{children}</div>);


export default Paragraph;